import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { RestoreContentAction } from '~src/spacesPlatform/actions/RestoreContentAction';
import { handleMoveContentAction } from '~src/spacesPlatform/sagas/content/MoveContentSaga';

// TODO: Add tests for RestoreContentsSaga [GUS: @W-16519720]
export function* restoreContents(action: RestoreContentAction): SagaIterator {
  try {
    try {
      const result = yield call(handleMoveContentAction, action);
    } catch (e) {
      return; // Catches the rejected dismiss-dialog promise
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.deleteFailed()));
  }
}
